<template>
  <div class="relative inline-block text-left">
    <button
      class="flex items-center gap-2 px-4 py-2 border border-gray-600 rounded-md hover:bg-gray-700 transition"
      @click="toggleDropdown"
    >
      <img
        :src="getFlagIcon(locale)"
        :alt="locale"
        class="w-5 h-5 rounded-full"
      />
      <span class="capitalize">{{ locale.toUpperCase() }}</span>
    </button>

    <!-- Dropdown -->
    <div
      v-if="isOpen"
      class="absolute right-0 mt-2 w-32 bg-[#1F1F1F] border border-gray-700 rounded-md shadow-lg z-50"
    >
      <ul class="py-1">
        <li
          v-for="lang in locales"
          :key="lang.code"
          class="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray-700 transition"
          @click="changeLanguage(lang.code)"
        >
          <img
            :src="getFlagIcon(lang.code)"
            :alt="lang.label"
            class="w-5 h-5 rounded-full"
          />
          {{ lang.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "#imports"; // Nuxt 3 shortcut
const { locale } = useI18n();

const isOpen = ref(false);

const locales = [
  { code: "tr", label: "Türkçe" },
  { code: "en", label: "English" },
];

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const changeLanguage = (lang: string) => {
  locale.value = lang;
  isOpen.value = false;
};

const getFlagIcon = (code: string) => {
  switch (code) {
    case "tr":
      return "https://flagcdn.com/w40/tr.png";
    case "en":
      return "https://flagcdn.com/w40/gb.png";
    default:
      return "";
  }
};
</script>
